import { ArpeggiSupportedChain } from '@arpeggi/shared'
import { ContractInterface } from 'ethers'

export interface ContractInformation {
  contractAddress: string
  abi: ContractInterface
  chain: ArpeggiSupportedChain
}
